type DetailField = 'address' | 'phone' | 'email' | 'instructions' | 'duration' | 'load' | 'timeWindow' | 'tags' | 'isPriority';

export type FilledField = DetailField | `customField:${string}`;

const CUSTOM_FIELD = 'customField:';
const SERVER_CUSTOM_FIELD = 'customFields.';

const SERVER_KEYS: Partial<Record<DetailField, string>> = {
  address: 'locations',
  phone: 'phone',
  email: 'email',
  instructions: 'instructions',
  duration: 'duration',
  load: 'load',
  timeWindow: 'timeWindows',
  tags: 'tags',
  isPriority: 'isPriority',
};

const FIELDS_BY_SERVER_KEY = Object.fromEntries(Object.entries(SERVER_KEYS).map(([field, key]) => [key, field])) as Record<string, DetailField>;

export const customField = (name: string): FilledField => `${CUSTOM_FIELD}${name}`;

export const customFieldName = (field: FilledField) => (field.startsWith(CUSTOM_FIELD) ? field.slice(CUSTOM_FIELD.length) : undefined);

export const customerCustomFields = (customer: { metadata?: unknown; notes2?: string | null }) => {
  const fields: Record<string, unknown> = { ...((customer.metadata ?? {}) as Record<string, unknown>) };
  if (customer.notes2?.trim()) fields.notes2 = customer.notes2.trim();
  return Object.fromEntries(Object.entries(fields)
    .map(([name, value]) => [name, value == null ? '' : String(value)])
    .filter(([, value]) => !['', 'null', 'undefined'].includes(value.trim())));
};

export const toCustomerFilledFieldKeys = (fields: FilledField[]): string[] => [...new Set(fields.flatMap((field) => {
  const name = customFieldName(field);
  if (name) return [`${SERVER_CUSTOM_FIELD}${name}`];
  const key = SERVER_KEYS[field as DetailField];
  return key ? [key] : [];
}))];

export const fromCustomerFilledFieldKeys = (keys?: readonly (string | null)[] | null): FilledField[] => (keys ?? []).flatMap((key) => {
  if (!key) return [];
  if (key.startsWith(SERVER_CUSTOM_FIELD)) return [customField(key.slice(SERVER_CUSTOM_FIELD.length))];
  const field = FIELDS_BY_SERVER_KEY[key];
  return field ? [field] : [];
});

type LinkedOrder = { customerId?: string | null; customerFilledFields?: readonly (string | null)[] | null } | null | undefined;

export const getFilledFields = (order: LinkedOrder): FilledField[] => (
  order?.customerId ? fromCustomerFilledFieldKeys(order.customerFilledFields) : []
);
